import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { crearClienteApi } from './api/cliente';
import { crearOperaciones } from './api/operaciones';
import { leerConfiguracion } from './config';
import { almacenDelNavegador, crearAlmacenSesion, crearRenovador } from './sesion/sesion';
import { crearFetchSimulado, opcionesDesdeDireccion } from './simulacion/simulacion';

const raiz = document.getElementById('raiz');
if (raiz === null) {
    throw new Error('Falta el elemento #raiz en index.html');
}

const config = leerConfiguracion();
const almacen = crearAlmacenSesion(almacenDelNavegador());
const simulada = opcionesDesdeDireccion(window.location.search);
// Con VITE_SIMULACION=1, la red del cliente de la API se sustituye por la simulación (forma exacta del contrato). Sin
// ella, el panel habla con la API real y renueva la sesión con el token de refresco cuando caduca el de acceso.
const cliente = crearClienteApi({
    base: config.api,
    obtenerToken: () => almacen.actual()?.accessToken ?? null,
    renovar: crearRenovador(almacen, (refresco) => ops.refreshSession(refresco)),
    ...(config.simulacion ? { fetch: crearFetchSimulado(simulada) } : {}),
});
const ops = crearOperaciones(cliente);

createRoot(raiz).render(
    <StrictMode>
        <App
            ops={ops}
            almacen={almacen}
            simulacion={config.simulacion}
            crearOps={(obtenerToken) =>
                crearOperaciones(crearClienteApi({ base: config.api, obtenerToken, ...(config.simulacion ? { fetch: crearFetchSimulado(simulada) } : {}) }))
            }
            crearApiCliente={(obtenerToken) => crearClienteApi({ base: config.api, obtenerToken, ...(config.simulacion ? { fetch: crearFetchSimulado(simulada) } : {}) })}
        />
    </StrictMode>,
);
